/** 从 consoles.ts 导出原始 Descriptor 供 modules.ts 复用 */
import { getConsole, LIVE_MENU } from '@/views/merchant/registry/consoles'

export const MALL = getConsole('MALL_SHOP')!
export const O2O = getConsole('O2O_ORG')!
export const CAPACITY = getConsole('CAPACITY')!
export const HOTEL = getConsole('HOTEL_SHOP')!
export const SCENIC = getConsole('SCENIC_SHOP')!
export const RENTAL = getConsole('RENTAL_SHOP')!
export const XUANXUE = getConsole('XUANXUE_SHOP')!
export { LIVE_MENU }
